import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "classes", "priority", "type", "color", "height", "fullScreen", "active", "extraClass", "spinner", "hidden", "style"],
  _excluded2 = ["isValidFunction", "disabled"];
import React from "react";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import myClasses from "./button.module.scss";
const getButtonClassColor = color => "mi_button_".concat(color);
const getButtonClassHeight = height => "mi_button_".concat(height);
const Button = props => {
  const {
      children,
      classes: propClasses,
      priority,
      type,
      color,
      height,
      fullScreen,
      active,
      extraClass,
      spinner,
      hidden,
      style
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  const classes = mergeClasses(myClasses, propClasses);
  const rootClassName = classes["mi_button"];
  const buttonColor = classes[getButtonClassColor(color)];
  const buttonHeight = classes[getButtonClassHeight(height)];
  const fullScreenClass = fullScreen ? classes["mi_button_fullscreen"] : "";
  const activeClass = active ? classes["mi_button_active"] : "";
  const hiddenClass = hidden ? classes["mi_button_hidden"] : "";
  return /*#__PURE__*/React.createElement("button", _extends({
    className: "".concat(rootClassName, " ").concat(fullScreenClass, " ").concat(activeClass, " ").concat(buttonColor, " ").concat(buttonHeight, " ").concat(extraClass, " uk-box-shadow-medium uk-animation-onclick ").concat(hiddenClass),
    type: type,
    style: style
  }, restProps), spinner ? spinner : /*#__PURE__*/React.createElement("span", {
    className: classes.content
  }, children));
};
Button.defaultProps = {
  priority: "normal",
  type: "button",
  color: "primary",
  height: "small",
  fullScreen: false,
  active: false,
  extraClass: ""
};
export const ButtonValidated = _ref => {
  let {
      isValidFunction,
      disabled
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded2);
  return /*#__PURE__*/React.createElement(Button, _extends({
    disabled: !isValidFunction()
  }, props));
};
export default Button;